const Products = {
    PayableAccount: 1,
    BuypassAccount: 2,
    BankAccount: 3
};

Object.freeze(Products);

export default Products;